import { render, staticRenderFns } from "./FormEmpresa.vue?vue&type=template&id=5c24a83a&scoped=true&lang=pug"
import script from "./FormEmpresa.vue?vue&type=script&lang=js"
export * from "./FormEmpresa.vue?vue&type=script&lang=js"
import style0 from "./FormEmpresa.vue?vue&type=style&index=0&id=5c24a83a&prod&lang=scss&scoped=true"
import style1 from "./FormEmpresa.vue?vue&type=style&index=1&id=5c24a83a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c24a83a",
  null
  
)

export default component.exports